import 'react-picky/dist/picky.css';
import React, {Component} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import get from 'get-value';
import PropTypes from 'prop-types';
import {
    lockDistributionTicket,
    resetRedirectAfterLockDistributionTicket
} from '../../../actions/distribution/actionDistributionLockTicket';
import {
    fetchDistributionPreferences,
    updateDistributionUserListPreference
} from '../../../actions/distribution/actionDistributionPreferences';
import {clearAlerts} from '../../../actions/alertsActions';
import {ColumnLibrary} from '../../common/table/DistributionColumnLibrary';
import {StyledPicky} from '../../common/StyledComponents';
import {domains} from '../../../constants/Utils';
import ListDistributionTable from './ListDistributionTable';
import checkRoles from '../../common/roleChecker/RoleChecker';
import Loader from '../../Loader';
import PageHeader from '../../common/PageHeader';
import listMessages from '../../../intl/modules/listMessages';
import tableMessages from '../../../intl/common/tableMessages';
import {moduleRoles} from '../../../utils/roles';
import {dealerMessageReadDistributionTicket} from '../../../actions/distribution/actionDistributionTicket';

const domain = domains.DISTRIBUTION;

class ListDistributionPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ratchet: false,
        }
    }

    componentWillUnmount() {
        this.props.resetRedirectAfterLockDistributionTicket();
    }

    componentDidMount() {
        this.props.fetchDistributionPreferences();
    }

    handleEditClick = ({id, styleInfo}) => {
        const isEditor = moduleRoles.isEditorDistribution(this.props.loggedUser);
        if (isEditor && styleInfo && styleInfo.unreadMessageFromDealer) {
            // send to backend that editor read the message
            this.props.dealerMessageReadDistributionTicket(id);
        }
        if (!this.props.lockTicket.isTicketLocking) {
            this.props.lockDistributionTicket(id);
            this.setState({ratchet: true})
        }
    };

    render() {
        const {intl, distributionPreferences, lockTicket, location, isLoadingSubjects} = this.props;
        const columnLibrary = ColumnLibrary(this.props, domain, true);
        const selectMultipleOption = (value) => {
            this.props.updateDistributionUserListPreference(
                columnLibrary.filter(item => !value.some(value => value.id === item.id)).map(column => column.id))
        };

        if (lockTicket.redirect && this.state.ratchet) {
            this.props.history.push(`/distribution/edit/${lockTicket.uuid}`);
        }
        if (distributionPreferences.isLoading
            || isLoadingSubjects
        ) {
            return <Loader/>;
        }

        return (
            <div className="container-fluid">
                <PageHeader title={<FormattedMessage {...listMessages.TITLE}/>}/>
                <div className="d-flex justify-content-end mb-3">
                    <div className="col-xl-4 col-lg-7 col-md-9 col-sm-12">
                        <span className="font-weight-bold">
                            <FormattedMessage {...tableMessages.VISIBLE_COLUMNS}/>
                            {':'}
                        </span>
                        <StyledPicky
                            value={columnLibrary.filter(item => !get(
                                distributionPreferences,
                                'menuList',
                                {default: []}).includes(item.id)).map(col => {
                                return {id: col.id, message: intl.formatMessage(col.message)}
                            })}
                            options={columnLibrary.map(col => {
                                return {id: col.id, message: intl.formatMessage(col.message)}
                            })}
                            onChange={selectMultipleOption}
                            open={false}
                            valueKey="id"
                            labelKey="message"
                            multiple={true}
                            includeSelectAll={true}
                            includeFilter={false}
                            dropdownHeight={600}
                        />
                    </div>
                </div>
                <ListDistributionTable
                    columns={
                        columnLibrary.filter(item =>
                            !get(distributionPreferences, 'menuList', {default: []}).includes(item.id))
                    }
                    handleEditClick={this.handleEditClick}
                    location={location}
                />
            </div>
        );
    }
}

ListDistributionPage.propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    clearAlerts: PropTypes.func.isRequired,
    updateDistributionUserListPreference: PropTypes.func.isRequired,
    lockDistributionTicket: PropTypes.func.isRequired,
    resetRedirectAfterLockDistributionTicket: PropTypes.func.isRequired,
    intl: PropTypes.any.isRequired,
};

const mapStateToProps = state => ({
    distributionPreferences: state.distributionPreferences,
    lockTicket: state.distributionListOrderLockTicketCheck,
    isLoadingSubjects: state.adminSubjectSettings.isLoading,
    listData: state.distributionList.listData,
    userDetail: state.profile.userDetail,
    subjects: state.adminSubjectSettings.subjectSettings.subjects,
    countryBU: state.adminBUAssignment.countryBU,
    loggedUser: state.profile.userDetail.roles,
});

export default checkRoles(withRouter(connect(mapStateToProps, {
    clearAlerts,
    updateDistributionUserListPreference,
    fetchDistributionPreferences,
    lockDistributionTicket,
    resetRedirectAfterLockDistributionTicket,
    dealerMessageReadDistributionTicket,
})(injectIntl(ListDistributionPage))), ['DB_DEALER', 'DB_EDITOR']);
